import * as React from "react";
import uncheck from '../../../resources/img/checkbox/checkbox_unchecked.png'
import check from '../../../resources/img/checkbox/checkbox_checked.png'
import PopDetail from "../../popdetail";
import AddNewProjectPane from "./add_new_project_pane";
import ReadService from "../../../service/read";
import Wait from "../../wait";
import SecondLayer from "../../container/second_layer";
import ProjectContainer from "./project_container";
import {ProjectsService} from "../../../service/v1/projects";
import {AuthorizationService} from "../../../service/v1/authorization";
import jwt_decode from "jwt-decode";
import {LocalitiesService} from "../../../service/v1/localities";
import AddNewMonitoringProjectPane from "./add_new_monitoring_project_pane";
import PopBig from "../../popbig";
import AddDodosoPane from "../../add/add_dodoso_pane";
import {generateUUID} from "../../../ug/uuid";
import MonitoringZonalPane from "./monitoring_zonal_pane";
import CollectService from "../../../service/v1/collect";

export default class MonitoringEvaluationListPane extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            rc_codes: [],
            userToSearch: '',
            modules: [],//'All Projects','Village LU','District LU','Regional LU','Zonal LU','National LU','CCRO','Urasimishaji'
            projects: [],
            syncBtn: 'Sync All',
            current_tab: 0,
            totalPages: 1,
            next: null,
            previous: null,
            pageSize: 20,
            questionnaires:[],
        }

        MonitoringEvaluationListPane.self = this
        this.fetchProjects = this.fetchProjects.bind(this)
        this.fetchProjectsByUrl = this.fetchProjectsByUrl.bind(this)
        this.loadQuestionnaires = this.loadQuestionnaires.bind(this)
        this.handleChange = this.handleChange.bind(this)
        MonitoringEvaluationListPane.loadData = MonitoringEvaluationListPane.loadData.bind(this)
    }

    handleChange = (e) => {
        this.setState({[e.target.name]: e.target.value})
    }

    toggleCheck(i, userId) {
        let doc = document.getElementById('chk_' + i);
        if (doc.src === uncheck) {
            doc.src = check;

            return;
        }
        doc.src = uncheck;
    }

    componentDidMount() {
        MonitoringEvaluationListPane.loadData()
    }

    static self;

    static loadData() {
        try {
            Wait.show('Loading...')
            ProjectsService.fetchMonitoringProjects().then(r => {
                Wait.dismiss()
                try {
                    let modules = [{name: 'All', id: 0}]
                    r.data.results.forEach(d => modules.push(d))
                    MonitoringEvaluationListPane.self.setState({modules: modules})
                } catch (e) {
                    console.log(e)
                }
                MonitoringEvaluationListPane.self.fetchProjects(0, {name: 'All', id: 0})
            })

        } catch (e) {
            console.log(e)
        }
    }

    fetchProjects(i = 0, d) {
        //this.setState({current_tab:i})
        try {
            Wait.show('Fetching Projects...')
            ProjectsService.fetchMonitoringProjects(this.props.moduleId).then(r => {
                Wait.dismiss()
                try {
                    //console.log(r.data)
                    this.setState({
                        projects: r.data.results,
                        totalPages: r.data.count,
                        next: r.data.next,
                        previous: r.data.previous
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
        }
    }

    fetchProjectsByUrl(url) {
        try {
            Wait.show('Fetching Projects...')
            ProjectsService.fetchProjectsByUrl(url).then(r => {
                Wait.dismiss()
                try {
                    this.setState({
                        projects: r.data.results,
                        totalPages: r.data.count,
                        next: r.data.next,
                        previous: r.data.previous
                    })
                } catch (e) {
                    console.log(e)
                }
            })
        } catch (e) {
            console.log(e)
        }
    }


    render() {

        return (<div style={{
                width: '98.9%', margin: '4px', border: '1px solid #dddd', padding: '4px',
                height: '90vh', borderTop: '1px solid #efefef', overflowX: 'hidden', overflowY: 'auto'
            }}>

                <div className={'col col-sm-12'} style={{
                    padding: '8px',
                    background: '#efefef',
                    border: '1px solid #ccc',
                    marginBottom: '4px',
                    width: '11.3%',
                    float: 'right'
                }}>
                    <button className={'btn submit'} style={{float: 'left'}} onClick={this.loadQuestionnaires}>
                        <span className={'fa fa-cogs fa-lg'}/>Zonal Management
                    </button>
                </div>

                <div className={'col col-sm-12'} style={{
                    padding: '8px',
                    background: '#efefef',
                    border: '1px solid #ccc',
                    marginBottom: '4px',
                    width: '9.5%',
                    float: 'right'
                }}>
                    <button className={'btn submit'} style={{float: 'left'}} onClick={() => {
                        PopDetail.show('Add New M & E Project', <AddNewMonitoringProjectPane loadProjects={MonitoringEvaluationListPane.loadData}
                                                                             key={new Date().getMilliseconds()}/>, 65)
                    }}>
                        <span className={'fa fa-plus'}/>Evaluate Project
                    </button>
                </div>

                <div className={'col col-sm-12'} style={{
                    padding: '4px',
                    background: '#efefef',
                    border: '1px solid #ccc',
                    marginBottom: '4px',
                    width: '99.5%',
                    float: 'left'
                }}>
                    <div className={'row'}>

                        <div className={'col col-sm-1'}></div>
                        <div className={'search-div col col col-sm-4'}>
                            <span className={'fa fa-search'}/>
                            <input name={'search'} onChange={this.handleChange}/>
                        </div>
                        <div className={'col col-sm-1'}></div>
                    </div>

                </div>

                <div className={'col col-sm-12'} style={{padding: '8px 0 2px 0', float: 'left'}}>
                    {/*{this.state.modules.map((d,i)=>{
                        return(<div onClick={()=>this.fetchModules(i,d)} key={i} className={this.state.current_tab===i?'tab tab-active':'tab'}>
                            <span className={'fa fa-file-o'}/>{d.name}</div>)
                    })}*/}
                </div>
                <div className={'col col-sm-12'}>
                    <table className={'tb'} style={{width: '100%'}}>
                        <thead>
                        <tr>
                            <th style={{textAlign: 'center', backgroundColor: 'white'}}>
                                <img id={'chk_0'} alt={'chk_0'} src={uncheck} onClick={() => this.toggleCheck(0)}/>
                            </th>
                            <th>Created Date</th>
                            <th style={{position: 'sticky', left: 0, zIndex: 2}}>Land Use</th>
                            <th>Description</th>
                            <th>Localities</th>
                            <th>Current Task</th>
                            <th style={{width: '150px'}}>Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.projects.map((d, i) => {
                                return (<tr key={i}
                                            onClick={() => SecondLayer.show(d.name, <ProjectContainer project={d}
                                                                                                      key={new Date().getMilliseconds()}/>)}>
                                    <td style={{textAlign: 'center', backgroundColor: 'white'}}>
                                        <img id={'chk_' + (i + 1)} alt={'chk_' + (i + 1)} src={uncheck}
                                             onClick={() => this.toggleCheck(i + 1, d.billRefNo)}/>
                                    </td>
                                    <td>{d.reg_date}</td>
                                    <td>
                                        <span style={{color: 'darkcyan'}}>{d.land_use.name === '' ? 'OTHER' : d.land_use.name}</span>
                                    </td>
                                    <td>{d.name}</td>
                                    <td style={{textAlign: 'center'}}>
                                        {typeof d.total_locality == 'undefined' ?
                                            <span style={{color: 'darkcyan'}}>1</span> :
                                            <span style={{color: 'darkcyan'}}>{d.total_locality}</span>}
                                    </td>
                                    <td>{d.current_task}</td>
                                    <td style={{color:'#084',fontWeight:'bold'}}>{d.status_info}</td>
                                </tr>)
                            })
                        }

                        <tr>
                            <td className={'noHover'} colSpan={7} style={{textAlign: 'center'}}>
                                <button onClick={() => {
                                    this.setState({
                                        pageSize: this.state.pageSize - 20
                                    })
                                    this.fetchProjectsByUrl(this.state.previous)
                                }} className={'btn default'}
                                        style={{visibility: this.state.previous !== null ? 'visible' : 'hidden'}}>Back
                                </button>
                                <b>{this.state.totalPages === 0 ? 0 : (this.state.pageSize) / 20}/{this.state.totalPages}</b>
                                <button onClick={() => {
                                    this.setState({
                                        pageSize: this.state.pageSize + 20
                                    })
                                    this.fetchProjectsByUrl(this.state.next)
                                }} className={'btn default'}
                                        style={{visibility: this.state.next !== null ? 'visible' : 'hidden'}}>Next
                                </button>
                            </td>
                        </tr>

                        </tbody>
                    </table>

                </div>
            </div>
        )
    }


    loadQuestionnaires(){
        try {
            Wait.show('Fetching Questions')
            CollectService.fetchQuestionsMonitoring(this.state.projects[0].project_type_info.id).then(r => {
                try {
                    Wait.dismiss()
                    let result = r.data.results
                    this.setState({
                        questionnaires:result,
                    })
                    /* if (result.length>0){
                         this.loadQuestionnairesForms(result[0].id)
                     }*/

                    PopBig.show('Zonal Management',
                        <MonitoringZonalPane loadData={()=>this.loadQuestionnaires()}
                                             uuid={generateUUID()} village={this.state.parent_hamlet}
                                             questionnaires={result}
                                             key={new Date().getMilliseconds()}/>)
                }catch (e) {
                    Wait.dismiss()
                    console.log(e)
                }
            })

        }catch (e) {
            console.log(e)
            Wait.dismiss()
        }


    }

}